import type { ITabsProps } from '@sixui/ui';
import { faEnvelope, faUserGroup } from '@fortawesome/pro-light-svg-icons';
import {
  faEnvelope as faEnvelopeSolid,
  faUserGroup as faUserGroupSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tab, TabList, Tabs } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';

export type IOrganizationUsersTabsProps = IContainerProps &
  ITabsProps & {
    organizationId: string;
  };

export const OrganizationUsersTabs: React.FC<IOrganizationUsersTabsProps> = (
  props,
) => {
  const { sx, organizationId, ...other } = props;
  const { t } = useTranslation();

  return (
    <Tabs variant="secondary" {...other}>
      <TabList sx={sx}>
        <Tab
          label={t('common.organizationUsers')}
          anchor="collaborators"
          href={`/organizations/${organizationId}/users`}
          icon={<FontAwesomeIcon icon={faUserGroup} />}
          activeIcon={<FontAwesomeIcon icon={faUserGroupSolid} />}
        />
        <Tab
          label={t('OrganizationUsersTabs.invitations')}
          anchor="invitations"
          href={`/organizations/${organizationId}/invitations`}
          icon={<FontAwesomeIcon icon={faEnvelope} />}
          activeIcon={<FontAwesomeIcon icon={faEnvelopeSolid} />}
        />
      </TabList>
    </Tabs>
  );
};
